/**
 * supabase-js's `detectSessionInUrl` predicate. A function there REPLACES the library's own
 * implicit-callback test (auth-js `_isImplicitGrantCallback`), so this repeats that test and adds
 * one exception: Google's consent return, whose `?error=` is Google's and not a Supabase sign-in
 * that failed (calendar-sync-requirements R3). The PKCE branch is not gated by it at all —
 * `public/oauth-return.js` keeps the `?code=` away from it.
 */

import { GOOGLE_RETURN_PATH } from '~/shared/lib/oauthReturn';

export function isSupabaseUrlCallback(
  url: URL,
  params: Readonly<Record<string, string | undefined>>,
): boolean {
  if (url.pathname === GOOGLE_RETURN_PATH) return false;
  return Boolean(params.access_token || params.error || params.error_description || params.error_code);
}
